import { createTheme } from '@mui/material/styles';

// Make sure you have these installed via npm or yarn:
// npm install @fontsource/poppins
// or
// yarn add @fontsource/poppins

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

export default theme;
